import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faHospitalUser, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'reactstrap';

const OpsStatsTableHeaders = (props) => {
    return (
        <Row className="sc-glass shadow text-light sc-rounded px-2 py-4 mb-4">
            <Col xs="12" className="mb-3">
                <h2 className="d-none d-md-block">Ops Statistics</h2>
                <h4 className="text-center d-md-none">Ops Statistics</h4>
            </Col>
            <Col xs="6" className="text-light border-bottom border-light">
                <div className="d-flex justify-content-center">
                    <span className="d-none d-md-inline text-18">
                        <FontAwesomeIcon icon={faUser} />
                        &nbsp;Team Member
                    </span>
                    <span className="d-md-none text-16">Team Member</span>
                </div>
            </Col>
            <Col xs="3" className="text-light border-bottom border-light">
                <div className="d-flex justify-content-center">
                    <span className="d-none d-md-inline text-18">
                        <FontAwesomeIcon icon={faHospitalUser} />
                        &nbsp;Assigned
                    </span>
                    <span className="d-md-none text-16">Assigned</span>
                </div>
            </Col>
            <Col xs="3" className="text-light border-bottom border-light">
                <div className="d-flex justify-content-center">
                    <span className="d-none d-md-inline text-18">
                        <FontAwesomeIcon icon={faCheck} />
                        &nbsp;Resolved
                    </span>
                    <span className="d-md-none text-16">Resolved</span>
                </div>
            </Col>
            {props.children}
        </Row>
    )
}

export default OpsStatsTableHeaders